export const PUBLIC_OFFER_VERSION = '01.08.2026';
export const PUBLIC_OFFER_URL = '/legal/holla-market-public-offer.pdf';

